// @flow
import React from 'react';
import classNames from 'classnames';
import arrowLongRight from 'assets/images/arrowLongRightGray.png';
import arrowLongRightCoral from 'assets/images/arrowLongRightHighlight.png';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  text?: string,
  disabled?: boolean,
  mode?: 'dark' | 'light' | 'transparent',
  className?: string,
  minimal?: boolean,
};

export const FormButton = (props: Props) => {
  const {
    disabled = false,
    text = 'Submit',
    mode = 'light',
    className = '',
    minimal = false,
    onClick,
  } = props;

  const imageSource =
    mode === 'transparent' ? arrowLongRightCoral : arrowLongRight;

  // add conditional classes
  const buttonClass = classNames('form-button', className, {
    dark: mode === 'dark',
    light: mode === 'light',
    transparent: mode === 'transparent',
    minimal,
  });

  return (
    <button
      type={'submit'}
      className={buttonClass}
      disabled={disabled}
      onClick={onClick}
    >
      <span>{text}</span>
      {!minimal && <img src={imageSource} alt="arrow icon" />}
    </button>
  );
};
